const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/settings/notifications/slack_app_health.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/common/hooks/usePermissions';
type HealthCheckStatus = 'pass' | 'fail' | 'warn' | 'unknown' | 'info';
type HealthCheckSeverity = 'critical' | 'warning' | 'info';
export const Route = createFileRoute('/(app)/org/$org/settings/notifications/slack_app_health')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  beforeLoad: requirePermission('edit_organization')
});